import { FC } from 'react';
import { Card } from 'antd';
import DividerAtom from 'components/atoms/DividerAtom';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import TextButton from 'components/atoms/Button/TextButton';
import PrimaryButton from 'components/atoms/Button/PrimaryButton';
import { TableFilterModel, TableFilterOptionModel } from '../../models';
import { TableFilterComponentManager } from '../ComponentsManager';
import './styles.scss';

interface Props {
  filters: TableFilterModel[];
  filterOptions: TableFilterOptionModel[];
  literals: Record<string, string>;
  onChangeFilter: (option: TableFilterOptionModel) => void
  onCloseFilters: () => void;
  onResetFilters: () => void;
  onApplyFilters: () => void;
  resetButtonDisabled: boolean;
  applyButtonDisabled: boolean;
}

export const DropdownContent: FC<Props> = ({
  filters,
  filterOptions,
  literals,
  onChangeFilter,
  onCloseFilters,
  onResetFilters,
  onApplyFilters,
  resetButtonDisabled,
  applyButtonDisabled,
}) => {
  return (
    <Card className={'DropdownContent__wrapper'}>
      <div className={'DropdownContent__wrapper-content'}>
        {filters.map(({ key, label, type }) => (
          <div key={key} className={'DropdownContent__wrapper-body'}>
            <p className={'DropdownContent__subtitle'}>{label}</p>
            {filterOptions
              .filter((filterOption) => filterOption.key.split(':')[0] === key)
              .map((option) => (
                <TableFilterComponentManager
                  key={option.key}
                  type={type}
                  onChangeFilter={onChangeFilter}
                  option={option}
                />
              ))}
          </div>
        ))}
      </div>
      <DividerAtom className={'DropdownContent__divider'} />
      <footer key={'footer'} className={'DropdownContent__footer'}>
        <DefaultButton onClick={onCloseFilters} title={literals.footerCloseButtonText} />
        <div>
          <TextButton onClick={onResetFilters} title={literals.footerSecondaryButtonText} disabled={resetButtonDisabled} />
          <PrimaryButton onClick={onApplyFilters} title={literals.footerMainButtonText} disabled={applyButtonDisabled} />
        </div>
      </footer>
    </Card>
  )
}
